<template>
  <!-- Thin wrapper: the insight-page tile is the same dashboard in compact
       mode, pointed at the auth-open summary endpoint (any authenticated user
       can see it there; the ETL endpoint is superuser-only). -->
  <Overview_ETL_Feed_Registry compact endpoint="/api/feed-registry/summary/" />
</template>

<script>
import Overview_ETL_Feed_Registry from '@/components/ETL_Utility/Overview_ETL_Feed_Registry.vue';

export default {
  name: 'FeedRegistryPanel',
  components: { Overview_ETL_Feed_Registry },
};
</script>
